import { Pipe, PipeTransform } from "@angular/core";
import { OOCanvasMenuItem } from "../models/oo-canvas-menu-item.model";
import { OOVenue } from "../models/oo-venue";

@Pipe({
	name: "ItemOutOfStockPipe",
	pure: false,
})
export class ItemOutOfStockPipe implements PipeTransform {
	transform(items: OOCanvasMenuItem[], venue: OOVenue): any {
		if (!items || !venue || venue.displayOutOfStockItems) {
			return items;
		}

		// filter items array, items which match and return true will be
		// kept, false will be filtered out
		return items.filter((item) => !item["outOfStock"]);
	}
}
